import {Controller} from '@hotwired/stimulus';
import {useIntersection} from 'stimulus-use';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        speed: {
            type: Number,
            default: 1.0,
        },
    };

    connect() {
        useIntersection(this, {
            threshold: 0.8,
            rootMargin: '-100px 0px -100px 0px',
            eventPrefix: false,
        });
    }

    disconnect() {
        this.stop();
    }

    appear() {
        if (!window.isPreviewRendered()) {
            if (this.speedValue > 1.0) {
                this.element.playbackRate = this.speedValue;
            }

            this.element.autoplay = true;
            this.element.muted = true;
            this.element.play();
        }
    }

    disappear() {
        this.stop();
    }

    stop() {
        this.element.autoplay = false;
        this.element.muted = true;
        this.element.pause();
    }
}
